{
    "lookupResorts":"index.php?option=com_kurortlife&format=json&task=ajax.lookupResorts",
    "resortDetails":"index.php?option=com_kurortlife&format=json&task=ajax.getResortDetails",
    "getPrices":"index.php?option=com_kurortlife&format=json&task=ajax.getResortPrices",
    "localStorageKeyForSearchCriterias":"searchCriteriasKey",
    "getProfile":"index.php?option=com_kurortlife&format=json&task=ajax.getProfile",
    "saveName":"index.php?option=com_kurortlife&format=json&task=ajax.saveName",
    "startPhoneVerification":"index.php?option=com_kurortlife&format=json&task=ajax.startPhoneVerification",
    "verifyPhone":"index.php?option=com_kurortlife&format=json&task=ajax.verifyPhone",
    "startEmailVerification":"index.php?option=com_kurortlife&format=json&task=ajax.startEmailVerification",
    "verifyEmail":"index.php?option=com_kurortlife&format=json&task=ajax.verifyEmail",
    "applyProfile":"index.php?option=com_kurortlife&format=json&task=ajax.applyProfile",
    "verifyProfile":"index.php?option=com_kurortlife&format=json&task=ajax.verifyProfile",
    "resendVerification":"index.php?option=com_kurortlife&format=json&task=ajax.resendVerification",
    "applyBookingContact":"index.php?option=com_kurortlife&format=json&task=ajax.applyBookingContact",
    "verifyBookingContact":"index.php?option=com_kurortlife&format=json&task=ajax.verifyBookingContact",
    "resendBookingVerification":"index.php?option=com_kurortlife&format=json&task=ajax.resendBookingVerification",

    "getBookings":"index.php?option=com_kurortlife&format=json&task=ajax.getBookings",
    "cancelBooking":"index.php?option=com_kurortlife&format=json&task=ajax.cancelBooking"
}
